<template>
    <div class="product-simulator">
        <simulation />
    </div>
</template>

<script>
    export default {
        name: 'ProductSimulator',
        methods: {

        },
        computed: {
            product(){
                return this.$store.getters.product;
            }
        }
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";

    .simulation
    {
        width: 100%;
        height: 100%;
    }
</style>